<template>
    <div class="add">
        <div class="container">
            <form @submit.prevent="add">
            <div class="form-group">
                <label for="exampleFormControlFile1">Portfolio Name</label>
                <input v-model="name" type="text" class="form-control" id="exampleFormControlFile1">
            </div>
             <div class="form-group">
                <label for="exampleFormControlFile3">Backend</label>
                <input v-model="backend" type="text" class="form-control" id="exampleFormControlFile3">
            </div>
            <div class="form-group">
                <label for="exampleFormControlFile2">Portfolio File</label>
                <input type="file" class="form-control-file" id="exampleFormControlFile2" accept="image/*"  @change="file">
                <img v-if="image" v-bind:src="this.fileurl" alt="uploaded url image" width="100px">
            </div>
            <button class="btn btn-primary btn-rounded form-control">Add</button>
            </form>
        </div>
    </div>
</template>

<script>
import db from './firebaseInit'
import firebase from 'firebase'
export default {
    name: "Add",
    data() {
        return {
            name : '',
            filename : null,
            fileurl : null,
            image: false,
            backend: ''
        }
    },
    methods: {
        add(){
          if(!this.fileurl){
                return
            }
          db.collection('portfolios').add({
            name: this.name,
            image: this.fileurl,
            backend: this.backend
          })
          .then(docRef => {
            console.log('Portfolio added: ', docRef.id)
            this.$router.push('/success')
          })
          .catch(error => {
            console.error('Error adding portfolios: ', error)
          })
        },
        file(e){
            const storageService = firebase.storage();
            const storageRef = storageService.ref();
            this.filename = e.target.files[0]
            console.log(this.filename   .name)
            const uploadTask = storageRef.child(`portfolios/${this.filename.name}`).put(this.filename);
             //create a child directory called images, and place the file inside this directory
             uploadTask.on('state_changed', (snapshot) => {
            // Observe state change events such as progress, pause, and resume
                this.percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused');
                break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running');
                break;
            }


            }, (error) => {
                // Handle unsuccessful uploads
                console.log(error);
            }, () => {
                // Do something once upload is complete
                 uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    console.log('File available at', downloadURL)
                    this.fileurl = downloadURL
                    this.image = true
                })
            });
        }
    },
}
</script>

<style>

</style>
